import useSWR from 'swr'
import { useAxiosApi } from './useAxiosApi'

const BETA_USER_IDS = ['3f3d3a00-8f4c-4378-9cae-294358b33c01']

export default function useMe() {
    const { requestGet } = useAxiosApi()

    const { data, isLoading, error } = useSWR(
        '/me/light',
        (url) => requestGet(url),
        {
            refreshInterval: 5 * 60 * 1000,
            // Share requests across screens and record activity while the tab
            // is visible. Focus revalidation is deduplicated for one minute.
            dedupingInterval: 60 * 1000,
            revalidateOnFocus: true,
        }
    )

    const me = data?.data

    const debugRole = localStorage.getItem('debug_role')
    const role = debugRole || me?.role

    return {
        id: me?.id,
        name: me?.name,
        role,
        realRole: me?.role,
        isAdmin: role === 'ADMIN',
        isBeta: BETA_USER_IDS.includes(me?.id),
        isLoading,
        // Profil non chargé : à distinguer d'un rôle absent, sous peine de
        // prendre une panne d'API pour un utilisateur sans droits
        error,
        isReady: !!me,
        debugRole,
    }
}
